import { exec, execSync } from 'child_process';
const createLoadError = (error) => new Error('Unable to load file from git: ' + error);
const createCommand = ({ ref, path }) => {
    return `git show ${ref}:${path}`;
};
/**
 * @internal
 */
export async function loadFromGit(input) {
    try {
        return await new Promise((resolve, reject) => {
            exec(createCommand(input), { encoding: 'utf-8' }, (error, stdout) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(stdout);
                }
            });
        });
    }
    catch (error) {
        throw createLoadError(error);
    }
}
/**
 * @internal
 */
export function loadFromGitSync(input) {
    try {
        return execSync(createCommand(input), { encoding: 'utf-8' });
    }
    catch (error) {
        throw createLoadError(error);
    }
}
//# sourceMappingURL=load-git.js.map